import React from "react";

import DownloadBtn from "./downloadBtn";
import ESelectType from "./eSelectType";

const Header = props => {
  const {
    documentId,
    einvoiceType,
    fileName,
    isEinvoice,
    setEinvoiceType,
    isDownloadVisible,
    setCurrentIndex,
    index
  } = props;
  // BEGIN REDUX STATE

  // END REDUX STATE

  return (
    <div className="headerB2b">
      {isEinvoice ? (
        <ESelectType
          einvoiceType={einvoiceType}
          setEinvoiceType={setEinvoiceType}
        />
      ) : (
        <div />
      )}
      {isDownloadVisible && <div style={{ marginRight: "20px" }}>
        <DownloadBtn
          documentId={documentId}
          fileName={fileName}
          isEinvoice={isEinvoice}
          setCurrentIndex={setCurrentIndex}
          index={index}
        />
      </div>}
    </div>
  );
};

export default Header;
